function mountPlayProduct(scope = document) {
  scope.querySelectorAll('[data-play-product]').forEach((root) => {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const select = root.querySelector('select[name="id"]');
    const form = root.querySelector('form[action*="/cart/add"]');
    const price = root.querySelector('[data-price]');
    const sticky = root.querySelector('[data-sticky-buy]');
    const update = () => {
      const option = select?.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      root.querySelectorAll('[data-buy]').forEach(button => {
        button.disabled = !available;
        button.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
      });
      const image = root.querySelector('[data-main-image]');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    select?.addEventListener('change', update);
    sticky?.addEventListener('click', () => form?.requestSubmit());
  });
}
mountPlayProduct();
document.addEventListener('shopify:section:load', e => mountPlayProduct(e.target));

function mountPlayMotion(scope = document) {
  scope.querySelectorAll('[data-motion-toggle]').forEach(button => {
    if (button.dataset.mounted) return;
    button.dataset.mounted = 'true';
    const image = button.parentElement.querySelector('[data-motion]');
    if (!image) return;
    const pauseText = button.textContent;
    const setPaused = paused => {
      image.src = paused ? image.dataset.poster : image.dataset.motion;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resume : pauseText;
    };
    setPaused(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    button.addEventListener('click', () => setPaused(button.getAttribute('aria-pressed') !== 'true'));
  });
}
mountPlayMotion();
document.addEventListener('shopify:section:load', e => mountPlayMotion(e.target));
